import request from '@/utils/request';
export const defaultIInventoryInwardsLogData = {
  id: 0,
  productId: 0,
  product: {
    id: 0
  },
  productsVariationId: 0,
  productsVariation: {
    id: 0
  },
  inventoryInwardId: null,
  inventoryInward: {
    id: null
  },
  unitId: 0,
  unit: {
    id: 0
  },
  adminId: 0,
  admin: {
    id: 0
  },
  quantity: 0,
  looseQuantity: 0,
  cartonQuantity: 0,
  masterCarton: 0,
  // extra cols
  currentStock: 0,
  rowSpan: 1
};
export const getInventoryInwardsLogs = params => request({
  url: '/inventory-inwards-logs',
  method: 'get',
  params
});
export const getInventoryInwardsLogById = id => request({
  url: `/inventory-inwards-logs/${id}`,
  method: 'get'
});
export const updateInventoryInwardsLog = (id, data) => request({
  url: `/inventory-inwards-logs/${id}`,
  method: 'patch',
  data
});
export const deleteInventoryInwardsLog = id => request({
  url: `/inventory-inwards-logs/${id}`,
  method: 'delete'
});
export const createInventoryInwardsLog = data => request({
  url: '/inventory-inwards-logs',
  method: 'post',
  data
});
export const manageInventoryInwardsLog = data => request({
  url: '/inventory-inwards-logs/manage',
  method: 'post',
  data
});
export const getStocksByInvoice = params => request({
  url: '/inventory-inwards-logs/stocks-by-invoice',
  method: 'get',
  params
});
export const downloadExcel = data => request({
  url: '/inventory-inwards-logs/download-stock-excel',
  method: 'post',
  data,
  responseType: 'blob'
});